module.exports = __webpack_public_path__ + "static/media/logout.c1772b38.svg";